import { defineComponent as _defineComponent } from 'vue'
import "flag-icons/sass/flag-icons.scss";


export default /*#__PURE__*/_defineComponent({
  __name: 'FlagIcon',
  props: {
    flag: { default: "us" },
    round: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})